var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "#E9EAEE",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8042 15.5535C16.3448 15.5397 15.1224 16.7244 15.1087 18.17C15.095 19.6671 16.2727 20.8998 17.7355 20.917C19.2155 20.9342 20.4585 19.753 20.4757 18.3073C20.4963 16.7759 19.3254 15.5706 17.8042 15.5535Z",
    fill: "#090710"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5741 15.4058C26.5706 14.5165 26.1826 13.7988 25.4856 13.2563C24.9911 12.8717 24.4245 12.6966 23.7996 12.6966C23.0854 12.7 22.3746 12.6966 21.6397 12.6966C21.5676 12.2914 21.5058 11.9068 21.4303 11.5222C21.2826 10.7908 20.6027 10.2277 19.861 10.2277C18.4978 10.2242 17.1346 10.2242 15.768 10.2277C14.9679 10.2208 14.2777 10.7942 14.1369 11.584C14.0854 11.8622 14.0339 12.1437 13.9961 12.4253C13.9687 12.6348 13.8863 12.7137 13.6631 12.7069C13.0038 12.6931 12.3445 12.7 11.6852 12.7069C10.2121 12.7206 9 13.9465 9 15.4195V21.4905C9 22.9807 10.2087 24.2134 11.6955 24.2169C15.7611 24.2272 19.8267 24.2272 23.8889 24.2203C25.3585 24.2169 26.5706 22.9773 26.5741 21.5042C26.5809 19.468 26.5844 17.4352 26.5741 15.4058ZM17.8042 22.2802C15.5345 22.2802 13.7352 20.4638 13.742 18.1803C13.7489 15.9758 15.5894 14.1799 17.8282 14.1903C20.0533 14.204 21.8389 16.017 21.8355 18.2593C21.832 20.4638 20.0087 22.2802 17.8042 22.2802ZM23.6039 16.1475C23.1987 16.1509 22.8656 15.8247 22.8622 15.4161C22.8622 15.4127 22.8622 15.4092 22.8622 15.4024C22.8759 15.0041 23.1952 14.6881 23.5936 14.6813C24.0228 14.6744 24.3352 14.98 24.3387 15.4058C24.3421 15.8316 24.0296 16.1475 23.6039 16.1475Z",
    fill: "#090710"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera2);
export default __webpack_public_path__ + "static/media/camera_2.8b1f9584cff46b46aed1658ef73fec02.svg";
export { ForwardRef as ReactComponent };